import * as React from 'react';
import { withUserType } from '../../components/withUserType';
import { useOscarContextEnabled } from './useAgentChatEnabled';

/**
 * Injects `oscarContextEnabled` (`useOscarContextEnabled`) into a class component, for a page that
 * changes its own layout to make room for the Ask Oscar input and must keep the old layout when the
 * input is off.
 */
export const withOscarContextEnabled = <P extends object>(Component: React.ComponentType<P>) => {
	const WithOscarContextEnabled = (props: P & { userType?: string }) => {
		const oscarContextEnabled = useOscarContextEnabled(props.userType);
		return <Component {...props} oscarContextEnabled={oscarContextEnabled} />;
	};
	return withUserType(WithOscarContextEnabled);
};

export default withOscarContextEnabled;
